export default "__VITE_ASSET__SDPBBRKU__"